import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_u3pfx7f42a: FaireBrandEntity = {
  token: "b_u3pfx7f42a",
  type: "brand",
  name: "Holy Tshili",
  avatarUrl:
    "https://cdn.faire.com/fastly/aee04dde1e912646c41e90e68f4af899fbf15bc01d560be365f6b2d5ea216577.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/43e459d3d41a9b96c075f1cf6b05ef565275880bfacc4cedf7e76e073a58c5d4.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/aee04dde1e912646c41e90e68f4af899fbf15bc01d560be365f6b2d5ea216577.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/43e459d3d41a9b96c075f1cf6b05ef565275880bfacc4cedf7e76e073a58c5d4.jpeg",
  location: "New york, NY, USA",
  minimumOrderDollars: 110,
  rating: 5,
  reviewCount: 3,
  isInsider: true,
  description:
    "At Holy Tshili, we’re serious suckers for tradition, soul, family, food and SAUCE. And we're obsessed with NYC's rich melting pot culture and foodie rituals! \n\nHoly Tshili is a small-batch, woman-owned, condiment brand. We are the lovechild of fiery Chinese chilis and crispy, savory everything bagel seeds in a collection of products that are inspired by, the melting pot that is NYC, with all the serious umami vibes! Holy Tshili Spicy (and Extra Spicy!) Everything Chili Crisp is made with luxurious roasted sesame oil and Holy Tshili Spicy Everything Furikake with fresh fragrant toasted nori from Japan.\n\nWe've got the sting of 1000 scorpions and the love of 1000 grandmas in every jar, and just like NYC, we’re not truly authentic, but we're bursting with authenticity! ",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:47.316Z",
    importedBy: "entity-db-cli",
  },
};
